import {
  Flex,
  Heading,
  Text,
  Card,
  RadioGroup,
  Box,
  Separator,
} from '@radix-ui/themes';
import { SunIcon, MoonIcon, DesktopIcon } from '@radix-ui/react-icons';
import { useTheme } from '../../contexts/ThemeContext';

export default function ProfilePage() {
  const { themePreference, setThemePreference, systemTheme } = useTheme();

  return (
    <Card size="3">
      <Flex direction="column" gap="5">
        <Heading size="6">Profile Settings</Heading>

        <Separator size="4" />

        <Flex direction="column" gap="4">
          <Flex direction="column" gap="1">
            <Heading size="4">Appearance</Heading>
            <Text size="2" color="gray">
              Customize how the application looks on your device
            </Text>
          </Flex>

          <RadioGroup.Root
            value={themePreference}
            onValueChange={(value) =>
              setThemePreference(value as 'light' | 'dark' | 'system')
            }
          >
            <Flex direction="column" gap="3" mt="2">
              <label style={{ cursor: 'pointer' }}>
                <Card variant="surface">
                  <Flex gap="3" align="center" p="1">
                    <RadioGroup.Item value="system" />
                    <Flex gap="3" align="center" style={{ flex: 1 }}>
                      <Box
                        style={{
                          padding: 'var(--space-2)',
                          borderRadius: 'var(--radius-2)',
                          backgroundColor: 'var(--gray-a3)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <DesktopIcon width="16" height="16" />
                      </Box>
                      <Box style={{ flex: 1 }}>
                        <Text size="3" weight="medium" as="div" mb="1">
                          Auto
                        </Text>
                        <Text size="2" color="gray" as="div">
                          Follow system preference (currently {systemTheme})
                        </Text>
                      </Box>
                    </Flex>
                  </Flex>
                </Card>
              </label>

              <label style={{ cursor: 'pointer' }}>
                <Card variant="surface">
                  <Flex gap="3" align="center" p="1">
                    <RadioGroup.Item value="light" />
                    <Flex gap="3" align="center" style={{ flex: 1 }}>
                      <Box
                        style={{
                          padding: 'var(--space-2)',
                          borderRadius: 'var(--radius-2)',
                          backgroundColor: 'var(--gray-a3)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <SunIcon width="16" height="16" />
                      </Box>
                      <Box style={{ flex: 1 }}>
                        <Text size="3" weight="medium" as="div" mb="1">
                          Light
                        </Text>
                        <Text size="2" color="gray" as="div">
                          Always use light mode
                        </Text>
                      </Box>
                    </Flex>
                  </Flex>
                </Card>
              </label>

              <label style={{ cursor: 'pointer' }}>
                <Card variant="surface">
                  <Flex gap="3" align="center" p="1">
                    <RadioGroup.Item value="dark" />
                    <Flex gap="3" align="center" style={{ flex: 1 }}>
                      <Box
                        style={{
                          padding: 'var(--space-2)',
                          borderRadius: 'var(--radius-2)',
                          backgroundColor: 'var(--gray-a3)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <MoonIcon width="16" height="16" />
                      </Box>
                      <Box style={{ flex: 1 }}>
                        <Text size="3" weight="medium" as="div" mb="1">
                          Dark
                        </Text>
                        <Text size="2" color="gray" as="div">
                          Always use dark mode
                        </Text>
                      </Box>
                    </Flex>
                  </Flex>
                </Card>
              </label>
            </Flex>
          </RadioGroup.Root>
        </Flex>
      </Flex>
    </Card>
  );
}
